import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { CODIGO_CENTRUS, DADOS_ACESSO_DECLARACAO_RENDIMENTO_EMPRESTIMO_FINANCIAMENTO } from '../../../app.constants';
import { CodigoTributacaoModel } from '../../shared/models/codigoTributacao.model';
import { CodigoTributacaoTotalModel } from '../../shared/models/codigoTributacaoTotal.model';
import { ContratoModel } from '../../shared/models/contatros.model';
import { PessoaDadosSimplicadosModel } from '../../shared/models/pessoa-simplificada.model';
import { PessoaService } from '../../shared/services/pessoa.service';
import { StorafeUtil } from '../../shared/util/storasge.util';
import { FinanceiroService } from '../service/financeiro.service';
import { DeclIrSefParamsDTO } from './../../shared/dominios/DTO/declIrSef-árams.DTO';
import { TipoDeclaracaoEnum } from './../../shared/dominios/enum/tipo-delcaracao';
import { DeclaracaoRendimentoEmpFinService } from './service/declaracao-rendimento-emp-fin.service';
import { MessageUtil } from '../../shared/messages/messageUtil';
import { AuthInterceptor } from '../../interceptor/auth.interceptor';

@Component({
  selector: 'app-declaracao-rendimento-emp-fin',
  templateUrl: './declaracao-rendimento-emp-fin.component.html',
  styleUrls: ['./declaracao-rendimento-emp-fin.component.css']
})
export class DeclaracaoRendimentoEmpFinComponent implements OnInit {

  @BlockUI() blockUi: NgBlockUI;

  param: string;

  componentes: any[] = [1];

  codigoTributacaoTotalModel: Array<CodigoTributacaoTotalModel> = new Array<CodigoTributacaoTotalModel>();
  codigoTributacaoModel: Array<CodigoTributacaoModel> = new Array<CodigoTributacaoModel>();

  contratos: Array<ContratoModel> = new Array<ContratoModel>();

  cdCentrus: number;
  versaoRetorno: number;


  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  titlePage: string;

  anoDeclardo: number;

  caminhoDeclaracao: string;

  declIrSefParamsDTO: DeclIrSefParamsDTO = new DeclIrSefParamsDTO();


  mostrarBotaoDetalhar: Boolean = false;

  tipoEmprestimo = [
    { title: 'Empréstimo Pessoal', value: 2 },
    { title: 'Empréstimo Pessoal', value: 3 },
    { title: 'Empréstimo Extraordinário', value: 5 },
    { title: 'Empréstimo Especial', value: 7 },
    { title: 'Financiamento Imobiliário', value: 0 },
    { title: 'Financiamento Imobiliário', value: 1 },
    { title: 'Financiamento Imobiliário', value: 4 },
    { title: 'Financiamento Imobiliário', value: 6 },
    { title: 'Empréstimo PREVI', value: 8 },
    { title: 'Financiamento PREVI', value: 9 }
  ]

  constructor(
    private declaracaoRendimentoEmpFinService: DeclaracaoRendimentoEmpFinService,
    private router: Router,
    private pessoaService: PessoaService,
    private activatedRoute: ActivatedRoute,
    private authInterceptor: AuthInterceptor,
    private toastrService: ToastrService
  ) {

  }


  ngOnInit() {
    this._gerenciarCodigoIndentificao();
  }


  getDadosSesseionStorage(): Promise<string> {
    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })

  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
    .then(recuperandoObjeto => {

      if (recuperandoObjeto) {
        const novoObjeto = Number(JSON.parse(recuperandoObjeto));
        this.cdCentrus = novoObjeto
        this.param = '/administrativo/operacoesConsultaParticipante';
      } else {
        this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
        this.param = '/cardMenus/cardMenuFinanceiro';
      }
      this._verificarTipoDeclaracaoRebdimento();
    })
  }



  private _verificarTipoDeclaracaoRebdimento(): void {
    const tipoRecebido = this.activatedRoute.snapshot.params.tipo;
    (tipoRecebido === 'emp') ? this.obterContratosEmp() : this.obterContratosFin()
  }



  async obterContratosEmp() {
    try {
      this.titlePage = 'EMPRÉSTIMO';
      this.caminhoDeclaracao = 'emp';
      this.getPessoasDadosSimplificado();
      this.anoDeclardo = await this.declaracaoRendimentoEmpFinService.getUltimaDataReferenciaISW(this.cdCentrus);
      this.getObterContratosEmp(this.cdCentrus, this.anoDeclardo)
    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', {timeOut: 8000});
    }
  }


  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);

    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }


  async getObterContratosEmp(cdCentrus, anobase: number) {

    try {
      this.declIrSefParamsDTO.tpEmpFin = 2;
      this.declIrSefParamsDTO.dtLancto = anobase;
      this.declIrSefParamsDTO.cdCentrus = cdCentrus;

      const contrato = await this.declaracaoRendimentoEmpFinService.getObterContratosEmp(cdCentrus, anobase);


      if (contrato.length === 0) {
        return  this.voltarForcada();
      }

      contrato.map(item => {
        this.contratos.push(
          new ContratoModel(item['nrContrato'],
            TipoDeclaracaoEnum.alocarTitle(parseInt(item['tpEmpFin'], 10)),
            parseFloat(item['vlLancto']),
            item['apresentaDeclaracaoAnalitica']))
      })

    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }

  async obterContratosFin() {

    try {
      this.titlePage = 'FINANCIAMENTO';
      this.caminhoDeclaracao = 'fin';
      this.getPessoasDadosSimplificado();

      this.anoDeclardo = await this.declaracaoRendimentoEmpFinService.getUltimaDataReferenciaISW(this.cdCentrus);

      this.getObterContratosFin(this.cdCentrus, this.anoDeclardo)
    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', {timeOut: 8000});
    }
  }


  async getObterContratosFin(cdCentrus, anobase: number) {

    try {

      this.declIrSefParamsDTO.tpEmpFin = 1;
      this.declIrSefParamsDTO.dtLancto = anobase;
      this.declIrSefParamsDTO.cdCentrus = cdCentrus;
      const contrato = await this.declaracaoRendimentoEmpFinService.getObterContratosFin(cdCentrus, anobase);

      if (contrato.length === 0) {
        return  this.voltarForcada();
      }

      contrato.map(item => {
        this.contratos.push(
          new ContratoModel(item['nrContrato'],
            TipoDeclaracaoEnum.alocarTitle(parseInt(item['tpEmpFin'], 10)),
            parseFloat(item['vlLancto']),
            item['apresentaDeclaracaoAnalitica']))
      })

    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }


  verDetalhe(nrContrato): void {
    this.declIrSefParamsDTO.nrContrato = nrContrato;
    this.gravaSessionStorage(DADOS_ACESSO_DECLARACAO_RENDIMENTO_EMPRESTIMO_FINANCIAMENTO, this.declIrSefParamsDTO)
    this.router.navigate(['/financeiros/declaracaoRendEmpFinDetalheComponent/', this.caminhoDeclaracao], { skipLocationChange: true });
  }


  gravaSessionStorage(titulo: string, declIrSefParamsDTO: DeclIrSefParamsDTO): void {
    StorafeUtil.gravaSessionStorage(titulo, declIrSefParamsDTO);
  }

  getUltimaDataReferenciaISW(cdCentrus) {
    this.declaracaoRendimentoEmpFinService.getUltimaDataReferenciaISW(cdCentrus);
  }




  voltarForcada(): void {
     this.router.navigate([this.param], { skipLocationChange: true });
    this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
  }



}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/declaracao-rendimento-emp-fin/declaracao-rendimento-emp-fin.component.ts